import type { MenuListEntry } from "@/components/Menu/Menu";
import { getActiveBackendSource, getBackendSourceLabel, isBackendSourceToggleAvailable } from "./resolve";
import { applyBackendSource, type BackendSource } from "./storage";

function buildBackendSourceItem(source: BackendSource, active: BackendSource): MenuListEntry {
  const label = getBackendSourceLabel(source);

  return {
    label,
    ariaLabel: active === source ? `Selected API backend: ${label}` : `Switch API backend to ${label}`,
    iconName: active === source ? "check" : undefined,
    reserveLeadingIconSpace: true,
    onClick: () => {
      if (active === source) return;

      applyBackendSource(source);
    },
    dataTestId: `backend-source-${source}`
  };
}

export function getBackendSourceMenuItems(): MenuListEntry[] {
  if (!isBackendSourceToggleAvailable()) {
    return [];
  }

  const active = getActiveBackendSource();

  return [
    { type: "headline", label: "API backend", useDivider: false },
    buildBackendSourceItem("shared-dev", active),
    { ...buildBackendSourceItem("localhost", active), useDivider: true }
  ];
}
